import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * Inline loading spinner for data sections (cards, tables, panels).
 * Unlike <Loader/>, which fills the viewport, this fills its container only.
 *
 *   {loading ? <SectionLoader /> : <Table rows={rows} />}
 */
const SectionLoader = ({ minHeight = "12rem", size = 32 }) => (
  <Box
    sx={{
      width: "100%",
      minHeight,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress size={size} />
  </Box>
);

export default SectionLoader;
